module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/golden_pin_design_award_logo-72e33d5ce06668284caf06dff47cd1c5.svg&quot;;"